import { Box } from "@mui/material";
import { FormikDatePicker } from "@shared";
import { FormikProps } from "formik";

import {
  ALL_COUNSELORS_OPTION_ID,
  FormikCounselorSelect,
} from "@/common/components/counselor-select/FormikCounselorSelect";
import { ALL_COURTS_OPTION_ID, FormikCourtSelect } from "@/common/components/court-select/FormikCourtSelect";
import { snapBackToAllOption } from "@/common/utils/allOption";
import { CourtHearingsFilterValues, CourtHearingsGrouping } from "@/pages/court-hearings/CourtHearings.types";
import { useTranslation } from "@/translations";

import { CourtHearingsGroupingToggle } from "../grouping-toggle/CourtHearingsGroupingToggle";

interface Props {
  formik: FormikProps<CourtHearingsFilterValues>;
  grouping: CourtHearingsGrouping;
  onGroupingChange: (grouping: CourtHearingsGrouping) => void;
}

export function CourtHearingsFilterBar({ formik, grouping, onGroupingChange }: Props) {
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="flex-start" flexWrap="wrap" gap={3}>
      <Box sx={{ minWidth: 180 }}>
        <FormikDatePicker fieldName="from" label={t("courtHearings.filter.from")} formik={formik} />
      </Box>
      <Box sx={{ minWidth: 180 }}>
        <FormikDatePicker fieldName="to" label={t("courtHearings.filter.to")} formik={formik} />
      </Box>
      <Box sx={{ minWidth: 260 }}>
        <FormikCourtSelect
          formik={formik}
          fieldName="courtId"
          label={t("courtHearings.filter.court")}
          includeAllOption
          onValueChange={snapBackToAllOption(formik, "courtId", ALL_COURTS_OPTION_ID)}
        />
      </Box>
      <Box sx={{ minWidth: 260 }}>
        <FormikCounselorSelect
          formik={formik}
          fieldName="counselorId"
          label={t("courtHearings.filter.counselor")}
          includeAllOption
          onValueChange={snapBackToAllOption(formik, "counselorId", ALL_COUNSELORS_OPTION_ID)}
        />
      </Box>
      <CourtHearingsGroupingToggle value={grouping} onChange={onGroupingChange} />
    </Box>
  );
}
